import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { Page } from '../../../components/Page'
import { AddressSchedulerForm } from './AddressSchedulerForm'

export const AddressSchedulerFormPage: FC = () => {
  const { sid: locationId } = useParams()
  return (
    <Page title={'Address Change Scheduler'}>{locationId && <AddressSchedulerForm title={'Schedule an Address Change'} sid={locationId} />}</Page>
  )
}
